import { Box, Button } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';

const BlogCategoryItem = ({ page }) => {
  const {path, data: item} = page;
  return (
    <Box display="flex" 
      sx={{ 
        flexDirection: 'column',
        border: '1px solid #707070',
        borderRadius:'30px',
        overflow: 'hidden'
      }}>
      <Box sx={{ 
        position: 'relative', 
        width: '100%', 
        minHeight: '250px',
        '@media(max-width:1000px)': {
          minHeight: '200px'
        }
      }}>
        <a href={'/' + path}>
          <Image src={`https://cms.tassomutuo.it/?p=${item?.featured_media}`} alt={item?.ogTitle} fill style={{ objectFit: 'cover' }} />
        </a>
      </Box>
      <Box sx={{padding:'30px'}}>

      <h2>
        {' '}
        <a href={'/' + path}>{item?.title?.rendered}</a>
      </h2>
      <Box type="p" dangerouslySetInnerHTML={{ __html: item?.excerpt?.rendered }} />
      <a href={'/' + path}>leggi di più</a>
      </Box>
    </Box>
  );
};

export default BlogCategoryItem;
